import React from "react";
import "./FooterLicense.css";
import { Box } from "@mui/material";

export const FooterLicense = () => {
  return (
    <Box className="footer-license">
      <Box className="footer-license__content">
        enomo.casino is owned and operated by Elsikora Group Limitada
        registration number: 3-102-923334, registered address: Province 06
        Puntarenas, Canton 11 Garabito, Jaco, East Side Of The Municipality Of
        Garabito, Sanchez Chavarria Law Firm, Costa Rica. Contact us
        support@enomo.casino. enomo.casino is licensed and regulated by the
        Government of the Autonomous Island of Anjouan, Union of Comoros and
        operates under License No ALSI-202503005-FI1. enomo.casino has passed
        all regulatory compliance and is legally authorized to conduct gaming
        operations for any and all games of chance and wagering.
      </Box>
    </Box>
  );
};
